(() => {
  const storageKey = "product-size-unit";
  const syncEventName = "product:size-unit-change";

  const getStoredUnit = () => {
    try {
      return window.localStorage.getItem(storageKey) === "in" ? "in" : "cm";
    } catch (error) {
      return "cm";
    }
  };

  const setStoredUnit = (unit) => {
    try {
      window.localStorage.setItem(storageKey, unit);
    } catch (error) {}
  };

  const broadcastUnitChange = (unit) => {
    document.dispatchEvent(new CustomEvent(syncEventName, { detail: { unit } }));
  };

  const getDisplayValue = (swatch, unit) => {
    if (!swatch) return "";
    const preferred = unit === "in" ? swatch.dataset.sizeIn : swatch.dataset.sizeCm;
    const fallback = unit === "in" ? swatch.dataset.sizeCm : swatch.dataset.sizeIn;
    return preferred || fallback || swatch.dataset.value || "";
  };

  const updateButtonState = (button, isActive) => {
    button.classList.toggle("active", isActive);
    button.style.background = isActive ? "#111" : "#fff";
    button.style.color = isActive ? "#fff" : "#666";
  };

  const updateFieldset = (fieldset, unit) => {
    fieldset.dataset.sizeUnit = unit;

    fieldset.querySelectorAll("[data-size-unit]").forEach((button) => {
      updateButtonState(button, button.dataset.sizeUnit === unit);
    });

    fieldset.querySelectorAll(".bls__option-swatch").forEach((swatch) => {
      const displayValue = getDisplayValue(swatch, unit);
      const label = swatch.querySelector(".size-label");
      const tooltip = swatch.querySelector(".bls_tooltip-content");

      if (label) label.textContent = displayValue;
      if (tooltip) tooltip.textContent = displayValue;
    });

    const activeSwatch = fieldset.querySelector(".bls__option-swatch.active");
    const displayValue = getDisplayValue(activeSwatch, unit);
    const selectedValue = fieldset.querySelector(".swatch-selected-value");
    const dropdownValue = fieldset.querySelector(".bls__color-dropdown-value");

    if (selectedValue && displayValue) selectedValue.textContent = displayValue;
    if (dropdownValue && displayValue) dropdownValue.textContent = displayValue;
  };

  const initQuickviewRoot = (root) => {
    if (!root || root.dataset.sizeUnitQuickviewReady === "true") return;

    const fieldsets = root.querySelectorAll('[data-size-option="true"]');
    if (!fieldsets.length) return;

    root.dataset.sizeUnitQuickviewReady = "true";

    const applyUnit = (unit) => {
      fieldsets.forEach((fieldset) => updateFieldset(fieldset, unit));
    };

    fieldsets.forEach((fieldset) => {
      fieldset.querySelectorAll("[data-size-unit]").forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          const unit = button.dataset.sizeUnit === "in" ? "in" : "cm";
          setStoredUnit(unit);
          applyUnit(unit);
          broadcastUnitChange(unit);
        });
      });

      fieldset.querySelectorAll(".bls__option-swatch").forEach((swatch) => {
        swatch.addEventListener("click", () => {
          window.requestAnimationFrame(() => {
            updateFieldset(fieldset, getStoredUnit());
          });
        });
      });
    });

    applyUnit(getStoredUnit());
  };

  const initAllQuickviews = (root = document) => {
    root
      .querySelectorAll("variant-radios-quickview")
      .forEach((quickviewRoot) => initQuickviewRoot(quickviewRoot));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAllQuickviews());
  } else {
    initAllQuickviews();
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches?.("variant-radios-quickview")) {
          initQuickviewRoot(node);
          return;
        }
        initAllQuickviews(node);
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  document.addEventListener(syncEventName, (event) => {
    const unit = event.detail?.unit === "in" ? "in" : "cm";
    initAllQuickviews();
    document
      .querySelectorAll('variant-radios-quickview [data-size-option="true"]')
      .forEach((fieldset) => updateFieldset(fieldset, unit));
  });
})();
